<script setup lang="ts">
import ButtonPrimary from '@buttons/button-primary.vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const router = useRouter();

const goToHome = () => {
	router.push({ name: 'Home' });
};
</script>

<template>
	<main class="page page-email-verified">
		<div class="page-email-verified__card">
			<div class="page-email-verified__header">
				<img
					src="/images/mail-icon.svg"
					alt=""
					class="page-email-verified__icon"
				/>
				<h2 class="page-email-verified__title">
					{{ t('emailVerified.title') }}
				</h2>
				<p class="page-email-verified__subtitle">
					{{ t('emailVerified.subtitle') }}
				</p>
			</div>
			<button-primary @click="goToHome">
				{{ t('emailVerified.button') }}
			</button-primary>
		</div>
	</main>
</template>

<style lang="scss">
.page-email-verified {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100%;

	&__card {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 3.2rem;
		padding: 3.2rem 4.1rem;
		border-radius: 2.4rem;
		background-color: var(--color-panel);
		width: 100%;
		max-width: 48rem;
	}

	&__header {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1.6rem;
		text-align: center;
	}

	&__icon {
		width: 4.6rem;

		@include min-desktop {
			width: 6.4rem;
		}
	}

	&__title {
		@include font-24-pro-bold;

		@include min-desktop {
			@include font-32-pro-bold;
		}
	}

	&__subtitle {
		@include font-16-pro-regular;
		color: rgba(var(--color-text-rgb), 0.5);
		line-height: 1.2;
	}

	.button-primary {
		width: 100%;
	}
}
</style>
